import React from 'react';
import { toast } from 'sonner';
import { Copy } from 'lucide-react';
import { fmtClock } from '../../../lib/aiInterviewApi';
import { Pill, Section } from '../recruiter/common';

const CLAIMS = [['Verified in depth', 'green'], ['Partially supported', 'amber'], ['Not supported', 'red'], ['Not discussed', 'slate']];
const TONE = Object.fromEntries(CLAIMS);

export function ClaimMatrix({ report, onSeek }) {
  const rows = report.claim_checks || [];
  return (
    <Section title="Résumé claim verification" testId="claim-matrix">
      <div className="iv-facts" style={{ marginTop: 0, marginBottom: '0.9rem' }}>
        {CLAIMS.map(([s, tone]) => (
          <div key={s} className="iv-fact" data-testid={`claim-count-${tone}`}><b>{rows.filter((r) => r.status === s).length}</b><span>{s}</span></div>
        ))}
      </div>
      {!rows.length ? <p className="iv-small">No résumé claims were checked.</p> : (
        <div className="iv-scroll-x">
          <table className="iv-table">
            <thead><tr><th>Claim</th><th>Status</th><th>Note</th><th>Moment</th></tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.claim} style={{ cursor: 'default' }} data-testid={`claim-row-${i}`}>
                  <td style={{ minWidth: 200 }}>{r.claim}</td>
                  <td><Pill tone={TONE[r.status]}>{r.status}</Pill></td>
                  <td className="iv-small" style={{ minWidth: 200 }}>{r.note}</td>
                  <td>{r.turn != null ? <button type="button" className="iv-btn iv-btn-ghost iv-btn-sm iv-mono" onClick={() => onSeek({ turn: r.turn, start_ms: r.start_ms })} data-testid={`claim-seek-${i}`}>{fmtClock(r.start_ms)}</button> : <span className="iv-small">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Section>
  );
}

const List = ({ items, testId }) => (items?.length ? (
  <ul className="iv-sub" style={{ paddingLeft: '1.1rem', display: 'grid', gap: '0.3rem', fontSize: '0.88rem' }} data-testid={testId}>{items.map((s) => <li key={s}>{s}</li>)}</ul>
) : <p className="iv-small">None noted.</p>);

export function InsightsPanel({ report }) {
  const copyQs = () => navigator.clipboard.writeText((report.suggested_questions || []).map((q, i) => `${i + 1}. ${q}`).join('\n')).then(() => toast.success('Questions copied'));
  return (
    <Section title="Summary for the human round" testId="report-insights">
      <p className="iv-sub" style={{ fontSize: '0.9rem' }} data-testid="report-summary">{report.summary}</p>
      <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', marginTop: '1rem' }}>
        <div><div className="iv-eyebrow" style={{ color: '#047857' }}>Strengths</div><List items={report.strengths} testId="report-strengths" /></div>
        <div><div className="iv-eyebrow" style={{ color: '#B45309' }}>Risks</div><List items={report.risks} testId="report-risks" /></div>
      </div>
      <div style={{ marginTop: '1rem' }}>
        <div className="iv-row" style={{ justifyContent: 'space-between' }}>
          <div className="iv-eyebrow">Suggested follow-up questions</div>
          {report.suggested_questions?.length > 0 && <button type="button" className="iv-btn iv-btn-ghost iv-btn-sm" onClick={copyQs} data-testid="report-copy-questions-btn"><Copy size={13} /> Copy</button>}
        </div>
        <List items={report.suggested_questions} testId="report-suggested-questions" />
      </div>
      {report.communication_notes && <p className="iv-small" style={{ marginTop: '0.75rem' }}><b>Answer clarity:</b> {report.communication_notes}</p>}
      <p className="iv-small" style={{ marginTop: '0.5rem' }}>Model {report.model} · prompt {report.prompt_version} · {report.advisory_label}</p>
    </Section>
  );
}
